import {React} from 'common'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {useI18n} from 'store/Store'
import {useFormContext} from 'react-hook-form'
import {Images} from 'appearance'
import WizardComponentWrapper from '../WizardComponentWrapper'

const PhoneDetails = () => {
    const {i18n} = useI18n()

    const formContext = useFormContext()
    const {
        control: formControl,
        formState: {errors: formErrors},
    } = formContext

    return (
        <WizardComponentWrapper sideImage={Images.REGISTER_STEP_1}>
            <FormTextInput
                name="username"
                label={i18n.t('users.phone')}
                control={formControl}
                fullWidth
                type="text"
                initialValue=""
                errors={formErrors}
                height="48px"
                style={{color: '#95969A'}}
                InputProps={{style: {background: '#FAFAFA'}}}
            />
        </WizardComponentWrapper>
    )
}

export default PhoneDetails
